import { __awaiter } from 'tslib';
import { ContextClassBase } from '../../core/service/RuntimeContext.js';
import 'long';
import { im_proto } from '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import { serialize, deserialize } from '../../core/utils/serializer.js';
import '../manager/AdapterManager.js';
import '../manager/types.js';
import '../../core/utils/ticker.js';
import './IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class IMHttpClient extends ContextClassBase {
    constructor(ctx) {
        super(ctx);
        this.option = ctx.option;
    }
    // 如果有 beacon 的实现则使用 beacon
    sendByBeacon(url, data) {
        return false;
    }
    sendBeacon(url, data) {
        setTimeout(() => {
            const result = this.sendByBeacon(url, serialize(data)); // 这里必须用 Uint8Array?
            if (!result) {
                void this.sendRequest(url, data);
            }
        }, 0);
    }
    sendRequest(url, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.send(url, 'POST', this.encode(data));
            return this.decode(resp);
        });
    }
    encode(data) {
        return serialize(data).buffer;
    }
    decode(data) {
        return im_proto.Response.create(deserialize(this.ctx, data));
    }
    get headers() {
        return Object.assign({ 'Accept': this.mime, 'Content-Type': this.mime }, this.option.httpHeaders);
    }
    // TODO: json support
    get mime() {
        return 'application/x-protobuf';
    }
    get dataType() {
        return 'arraybuffer';
    }
    get method() {
        return 'POST';
    }
}

export { IMHttpClient };
//# sourceMappingURL=IMHttpClient.js.map
